import React from 'react';

interface LogoProps {
  size?: number;
  white?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 40 }) => {
  return (
    <img
      src="/logo.png"
      alt="AI Team"
      style={{
        height: size,
        width: 'auto',
        objectFit: 'contain',
      }}
    />
  );
};

export default Logo;
